import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory, EntityDataService } from '@ngrx/data';
import { WorkflowsListDataService } from './workflows-list-data.service';
import { KE_WORKFLOWS_LIST_ENTITY_NAME } from '@selfai-platform/store';
import { WorkflowInfo } from '@selfai-platform/pipeline-common';

@Injectable({ providedIn: 'root' })
export class WorkflowsListStore extends EntityCollectionServiceBase<WorkflowInfo> {
  constructor(
    public entityDataService: EntityDataService,
    public workflowsListService: WorkflowsListDataService,
    public serviceElementsFactory: EntityCollectionServiceElementsFactory,
  ) {
    entityDataService.registerService(KE_WORKFLOWS_LIST_ENTITY_NAME, workflowsListService);
    super(KE_WORKFLOWS_LIST_ENTITY_NAME, serviceElementsFactory);
  }

  [name: string]: unknown;
}
